import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject, signal } from '@angular/core';
import { Observable, catchError, of, tap } from 'rxjs';
import { environment } from '@environment';
import { CompletedQuiz } from '../models/completed-quiz.types';

@Injectable({ providedIn: 'root' })
export class HistoryService {
  private http = inject(HttpClient);

  readonly games = signal<CompletedQuiz[]>([]);

  load(gameId?: string): Observable<CompletedQuiz[]> {
    const params = gameId ? new HttpParams().set('gameId', gameId) : undefined;

    return this.http
      .get<CompletedQuiz[]>(`${environment.backendUrl}/completed-quiz`, {
        params,
      })
      .pipe(
        tap((res) => this.games.set(res ?? [])),
        catchError((err) => {
          console.error('[history] failed to load', err);
          return of([]);
        }),
      );
  }
}
